import React, { useState, useEffect } from 'react';
import { enableAnalytics, trackCookieConsent } from '../../utils/analytics';
import './CookieConsent.scss';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    console.log('Current cookie consent state:', consent);
    if (consent) {
      setIsVisible(false);
      if (consent === 'accepted') {
        trackCookieConsent(true);
      }
    }
  }, []);

  const handleAccept = () => {
    console.log('CookieConsent: Accepting cookies');
    localStorage.setItem('cookieConsent', 'accepted');
    enableAnalytics();
    trackCookieConsent(true);
    setIsVisible(false);
  };

  const handleDecline = () => {
    console.log('CookieConsent: Declining cookies');
    localStorage.setItem('cookieConsent', 'declined');
    trackCookieConsent(false);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <p>We use cookies to enhance your experience and analyze our website traffic.</p>
      <div className="cookie-consent__buttons">
        <button className="btn btn--primary" onClick={handleAccept}>
          Accept
        </button>
        <button className="btn btn--secondary" onClick={handleDecline}>
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
